<template>
    <BaseWidget
        :class="[widget.type]"
        :loading="loading" 
        :widget-options="widgetMenuOptions" 
        @refresh-data="refreshData" 
        v-on="$listeners"
    >

    <template v-slot:header>
      <div class="title">
        <span class="title-icon">
        </span>
        <translate>Accountant</translate>
      </div>
      <div class="description" v-translate>The accountant connected to your account</div>
    </template>

    <template v-slot:content>
        <portal to="dash-modal">
            <AccountantInfoModal 
                v-if="showModal"
                @disconnected="onDisconnected"
                @close-modal="showModal = false"
                :accountantCompanyProfile="accountantCompanyProfile" 
                :accountantId="accountantId" 
            />
        </portal>
        

        <div v-if="!loading" class="accountant-info-container">
            <div class="accountant-info">
                <b-avatar
                    class="company-info-card--avatar avatar" 
                    :src="(accountantCompanyProfile.logo_thumbnail) ? accountantCompanyProfile.logo_thumbnail : ''" 
                    :text="accountantCompanyProfile.name[0]" size="5rem" />

                <div class="accountant-name-container">
                    <div class="accountant-name">{{ accountantCompanyProfile.name }}</div>
                    <div class="accountant-small-info"><font-awesome-icon icon="fa-solid fa-envelope" class="mr-1" />{{ accountantCompanyProfile.email }}</div>
                    <div class="accountant-small-info"><font-awesome-icon icon="fa-solid fa-phone" class="mr-1" />{{ accountantCompanyProfile.phone_number }}</div>
                </div>
            </div>

            <div class="manage-connection-button">
                <GekkoButton 
                    @click="manageConnection()"
                    :text="$gettext('Manage connection')"
                    variant="link text-blue"
                />
            </div>
        </div>
    </template>

    
  </BaseWidget>
</template>

<script>
import CompanyService from "@/store/services/company.service";
import { mapGetters } from "vuex";
import BaseWidget from "@/components/dashboard/widgets/BaseWidget";
import GekkoButton from "@/components/GekkoButton";
import AccountantInfoModal from "@/components/dashboard/ui/AccountantInfoModal";

export default {
    name: 'accountant-widget',
    components: { BaseWidget, GekkoButton, AccountantInfoModal },
    props: {
      widget: {
        type: Object,
        default: () => {}
      },
    },
    data() {
        return {
            accountantId: null,
            accountantCompanyProfile: {
                name: "-"
            },
            loading: true,
            showModal: false
        }
    },
    created() {
        this.getData();
    },
    methods: {
        getData() {
            if(this.currentCompany.has_accountant && this.currentCompany.accountant_branding) {
                CompanyService.retrieveAccountant(this.currentCompany.accountant_branding.id).then((response) => {
                    this.accountantId = response.data.id;
                    if (response.data.company_profile)
                        this.accountantCompanyProfile = response.data.company_profile;
                    this.loading = false;
                });
            }
        },
        refreshData() {
            this.loading = true;
            this.getData();
        },
        manageConnection() {
            document.body.classList.add('modal-on');
            this.showModal = true;
        },
        onDisconnected() {
            this.$emit("widget-event", {event: "remove"});
        }
    },
    computed: {
        ...mapGetters({
            currentCompany: 'main/getCurrentCompany'
        }),
        widgetMenuOptions () {
           return [];
        }
    },
}
</script>

<style lang="scss">
.accountant-info {
    display: flex;
    flex-direction: row;
    align-items: center;
}

.accountant-info-container {
    display: flex;
    flex-direction: column;
    align-self: center;
    width: 100%;
}

.manage-connection-button {
    text-align: center;
}

.accountant-name-container {
    padding-left: 10px;
}

.accountant-name {
    font-size: 20px;
    font-weight: 900;
}

.accountant-small-info {
    font-size: 14px;
    color: $colorTextSemi;
}
</style>
  